import script from "./SubmissionEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionEmail.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionEmail.vue?vue&type=style&index=0&id=7276d388&lang=scss"

const __exports__ = script;

export default __exports__